import { render } from "./boost-analytics.vue?vue&type=template&id=046a596f"
import script from "./boost-analytics.vue?vue&type=script&lang=js"
export * from "./boost-analytics.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__